module.exports = __webpack_public_path__ + "static/media/noun-arrow-1256499-FFFFFF.cfb9f54a.svg";